/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

export type NativeCheckboxProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * A native checkbox that ticks in the Housien red instead of the browser's
 * default blue.
 *
 * `accent-color` rather than a hand-drawn box: the native control keeps its
 * platform focus ring, keyboard behaviour and forced-colors handling, and
 * only the fill follows the brand. A caller that genuinely needs another
 * colour still overrides it through `style`, since that is spread last.
 */
export const NativeCheckbox = React.forwardRef<HTMLInputElement, NativeCheckboxProps>(
  ({ style, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      style={{ accentColor: 'var(--seed-base)', ...style }}
      {...props}
    />
  )
);

NativeCheckbox.displayName = 'NativeCheckbox';
